import { useCallback, useEffect } from 'react';
import { Route } from 'react-router-dom';
import { Redirect, useHistory } from 'react-router';
import { useSetRecoilState } from 'recoil';
import { historyRouteState } from 'src/store/global/historyState';
import ManageStorage from 'src/shared/global/manageStorage';

export const PublicRouter = ({
    isAuthenticated,
    component: Component,
    ...rest
}) => {
    const setHistoryRoute = useSetRecoilState(historyRouteState);
    let history = useHistory()

    ManageStorage.setItemStorage("currentUrl", history.location.pathname)
    
    let historyCallback = useCallback(() => {
        setHistoryRoute({...history})

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        historyCallback()

        return () => {
            historyCallback()
        }
    }, [historyCallback])

    return (
        <Route
            {...rest}
            component={(props) => (
                (isAuthenticated && !history.location.pathname.includes("buscar") && !history.location.pathname.includes("eliminar") )
                ? (<Redirect to={`${process.env.REACT_APP_ROOT_SERVER_PATH}/paciente/reservas`} />)
                : <Component {...props} />
            )}
        />
    )
}
